import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION,
  FETCH_CHEMISTPAYMENTDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTPAYMENTDETAILS_FAIL_ACTION,
  FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION,
  FETCH_CHEMISTPAYMENTSTATUSCHANGE_SUCCESS_ACTION,
  FETCH_CHEMISTPAYMENTSTATUSCHANGE_FAIL_ACTION,
  FETCH_CHEMISTPAYMENTSEARCH_INIT_ACTION,
  FETCH_CHEMISTPAYMENTSEARCH_SUCCESS_ACTION,
  FETCH_CHEMISTPAYMENTSEARCH_FAIL_ACTION,
  FILTER_BY_CHEMISTPAYMENT_STATUS_INIT_ACTION,
  FILTER_BY_CHEMISTPAYMENT_STATUS_SUCCESS_ACTION,
  FILTER_BY_CHEMISTPAYMENT_STATUS_FAIL_ACTION
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchChemistPayment(value) {
  const token = localStorage.getItem("token");
  let pageno = ((!value.value) ? 1 :(value.value.page === undefined ? 1 : value.value.page));
  let search = ((!value.value) ? "" :(value.value.search=== "" ? "":value.value.search));
  let status=((!value.value) ? "" :(value.value.filter ==="" ? "":value.value.filter));
  try {
    const res = yield fetch(
      `${appConfig.ip}/payment?userMode=distributor&&limit=10&page=${pageno}&search=${search}&status=${status}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CHEMISTPAYMENTDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTPAYMENTDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistPaymentStatusChange(data) {
  let datas;

  data.value.item.status === "paid"
    ? (datas = {
        status: "cancelled"
      })
    : (datas = {
        status: "paid"
      });

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/payment/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_CHEMISTPAYMENTSTATUSCHANGE_SUCCESS_ACTION,
        payload: resJSON
      });

      yield put({
        type: FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTPAYMENTSTATUSCHANGE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* ChemistPaymentActionWatcher() {
  yield takeEvery(FETCH_CHEMISTPAYMENTDETAILS_INIT_ACTION, fetchChemistPayment);
  yield takeEvery(FETCH_CHEMISTPAYMENTSTATUSCHANGE_INIT_ACTION, fetchChemistPaymentStatusChange);
}
